export default __webpack_public_path__ + "static/GHG_logo_white-icon-dce8194f169cd8c02ec04a4235a069d4.svg";